// Bedtime with You — live preview (covers + photo + dedication + edit modals).
// Uses the SAME coords/fonts as the print generator (WYSIWYG). Asset URLs + coord
// URLs are injected by the template via window.BEDTIME. Reuses personalizationDB (loadProfile/saveProfile).
(function () {
  const A = window.BEDTIME || {};
  const PAGE = 2551, FRONT = { hard:{w:2783,h:3024}, soft:{w:2783,h:2822} };
  const COVER_SCALE = 4.62; // display width = full cover px / COVER_SCALE  (~602px, matches Blessed)
  let coverCoords, extras, storyText, storyCoords;
  const STORY_PAGE = 1160; // text-page canvas px (matches split page images; crisp at ~580px retina)
  const cache = {};
  const loadImg = (src) => cache[src] || (cache[src] = new Promise((res,rej)=>{const im=new Image();im.crossOrigin="anonymous";im.onload=()=>res(im);im.onerror=rej;im.src=src;}));

  function pron(g){ return g==="GIRL"?{He:"She",he:"she",his:"her",him:"her"}:{He:"He",he:"he",his:"his",him:"him"}; }
  function fill(line,name,g){ const P=pron(g); return (line||"").replace(/\{name\}/g,name||"").replace(/\{He\}/g,P.He).replace(/\{he\}/g,P.he).replace(/\{his\}/g,P.his).replace(/\{him\}/g,P.him); }
  function drawLines(ctx,lines,c,opts){ opts=opts||{}; let fs=c.font_size, lh=c.line_height;
    const widest=()=>{ctx.font=`${fs}px Newsreader`;return Math.max(0,...lines.map(l=>ctx.measureText(l).width));};
    if(opts.maxWidth){const w=widest();if(w>opts.maxWidth){const k=opts.maxWidth/w;fs*=k;lh*=k;}}
    if(opts.maxBottom){const b=c.y0+(lines.length-1)*lh;if(b>opts.maxBottom){const k=(opts.maxBottom-c.y0)/((lines.length-1)*lh||1);fs*=k;lh*=k;}}
    ctx.fillStyle=c.colour;ctx.textAlign="center";ctx.textBaseline="alphabetic";ctx.font=`${fs}px Newsreader`;
    lines.forEach((ln,i)=>ctx.fillText(ln,c.cx,c.y0+i*lh)); }
  function roundRect(ctx,x,y,w,h,r){ctx.beginPath();ctx.moveTo(x+r,y);ctx.arcTo(x+w,y,x+w,y+h,r);ctx.arcTo(x+w,y+h,x,y+h,r);ctx.arcTo(x,y+h,x,y,r);ctx.arcTo(x,y,x+w,y,r);ctx.closePath();}
  function nameCoords(name, gender, cover){ let c=coverCoords[`${gender==="GIRL"?"girl":"boy"}-${cover}`]; if(typeof c==="string")c=coverCoords[c];
    const len=Math.max(3,Math.min(11,(name||"").trim().length||3)); return c[String(len)]; }
  // artwork key for the chosen character: boy | boy_dark | girl | girl_dark (future).
  // Dark falls back to the light asset if the dark one isn't wired up (mirrors the backend).
  function charKey(gender, tone){ const base=gender==="GIRL"?"girl":"boy"; return tone==="dark"?base+"_dark":base; }
  function coverAsset(gender, tone, cover){ return A["cover_"+charKey(gender,tone)+"_"+cover] || A["cover_"+(gender==="GIRL"?"girl":"boy")+"_"+cover]; }

  // Front cover: draw the FULL cover art (no trim) + "with [Name]" at raw coords — identical to the print generator.
  async function renderCover(canvasId, cover, name, gender, tone){
    const cv=document.getElementById(canvasId); if(!cv) return;
    const F=FRONT[cover]; cv.width=F.w; cv.height=F.h; const ctx=cv.getContext("2d");
    cv.style.width=Math.round(F.w/COVER_SCALE)+"px"; cv.style.height="auto";
    ctx.drawImage(await loadImg(coverAsset(gender,tone,cover)), 0,0,F.w,F.h);
    const c=nameCoords(name,gender,cover);
    const measure=(ws,ns)=>{ctx.font=`${ws}px Chewy`;const w1=ctx.measureText("with").width;ctx.font=`${ns}px Chewy`;const w2=ctx.measureText(name).width;return{w1,w2,total:w1+c.gap+w2};};
    let ws=c.with_size,ns=c.name_size,m=measure(ws,ns);
    if(m.total>c.max_width){const k=c.max_width/m.total;ws*=k;ns*=k;m=measure(ws,ns);}
    const sx=c.cx-m.total/2; ctx.fillStyle=c.colour; ctx.textAlign="left"; ctx.textBaseline="alphabetic";
    ctx.font=`${ws}px Chewy`; ctx.fillText("with",sx,c.cy); ctx.font=`${ns}px Chewy`; ctx.fillText(name,sx+m.w1+c.gap,c.cy);
  }
  // Back cover: shared night-sky art + personalised white text (back_soft / back_hard coords).
  async function renderBack(canvasId, cover, name, gender){
    const cv=document.getElementById(canvasId); if(!cv) return;
    const F=FRONT[cover]; cv.width=F.w; cv.height=F.h; const ctx=cv.getContext("2d"); // display width via .back-cover-image CSS
    ctx.drawImage(await loadImg(A["back_"+cover]),0,0,F.w,F.h);
    const bc=cover==="hard"?extras.back_hard:extras.back_soft;
    const lines=(storyText.back_cover_text.lines||[]).map(l=>fill(l,name,gender));
    drawLines(ctx,lines,{cx:bc.cx,y0:bc.y0,font_size:bc.font_size,line_height:bc.line_height,colour:bc.colour});
  }
  async function renderPhoto(profile){
    const cv=document.getElementById("photoCanvas"); if(!cv) return;
    cv.width=PAGE; cv.height=PAGE; const ctx=cv.getContext("2d"); cv.style.width="100%"; cv.style.height="auto";
    ctx.drawImage(await loadImg(A.photo_frame),0,0,PAGE,PAGE);
    if(profile && profile.imageBase64){ const p=await loadImg(profile.imageBase64); const b=extras.photo_box;
      ctx.save(); roundRect(ctx,b.x,b.y,b.w,b.h,b.corner_radius); ctx.clip();
      const s=Math.max(b.w/p.width,b.h/p.height), dw=p.width*s, dh=p.height*s;
      ctx.drawImage(p,b.x+(b.w-dw)/2,b.y+(b.h-dh)/2,dw,dh); ctx.restore(); }
  }
  async function renderDed(profile){
    const cv=document.getElementById("messageCanvas"); if(!cv) return;
    cv.width=PAGE; cv.height=PAGE; const ctx=cv.getContext("2d"); cv.style.width="100%"; cv.style.height="auto";
    ctx.drawImage(await loadImg(A.dedication_bg),0,0,PAGE,PAGE);
    const d=extras.dedication, name=(profile&&profile.name)||"", g=(profile&&profile.gender)||"GIRL";
    const raw=(profile&&profile.dedicationText)||storyText.dedication_default.lines.join("\n");
    const lines=raw.split("\n").map(l=>fill(l,name,g));
    drawLines(ctx,lines,{cx:d.cx,y0:d.y0,font_size:d.font_size,line_height:d.line_height,colour:d.colour},{maxWidth:PAGE-2*260,maxBottom:PAGE-300});
  }
  // story spread items: spread 9 splits into 9a (above baked Surah block) + 9b (below).
  function storyItemsFor(meta){
    if(meta.n===9) return [{id:"9a",lines:meta.lines_before},{id:"9b",lines:meta.lines_after}];
    return [{id:String(meta.n),lines:meta.lines}];
  }
  // Each spread is shown as TWO square pages (Blessed structure) for crisp, non-blurry
  // display. The text-side page is a canvas (illustration + code-rendered Newsreader text,
  // WYSIWYG with the generator); the illustration-only page is a plain <img>.
  async function makeTextPage(meta, pgUrl, name, g){
    const cv=document.createElement("canvas"); cv.width=STORY_PAGE; cv.height=STORY_PAGE;
    cv.style.width="100%"; cv.style.height="auto"; const ctx=cv.getContext("2d");
    if(pgUrl) ctx.drawImage(await loadImg(pgUrl),0,0,STORY_PAGE,STORY_PAGE);
    const kk=STORY_PAGE/PAGE, offset=meta.text_side==="right"?PAGE:0;
    ctx.save(); ctx.scale(kk,kk); // draw text in half-page coords (spread coord − offset)
    for(const item of storyItemsFor(meta)){
      const co=storyCoords[item.id]; if(!co) continue;
      const lines=item.lines.map(l=>fill(l,name,g));
      drawLines(ctx,lines,{cx:co.cx-offset,y0:co.y0,font_size:co.font_size,line_height:co.line_height,colour:co.colour});
    }
    ctx.restore(); return cv;
  }
  function makeImgPage(pgUrl){ const im=new Image(); im.src=pgUrl||""; im.style.width="100%"; im.style.height="auto"; im.alt=""; return im; }
  async function renderStory(name, g, tone){
    const grid=document.getElementById("story-pages"); if(!grid||!storyText||!storyCoords) return;
    grid.innerHTML="";
    const pages=(A.pages&&(A.pages[charKey(g,tone)]||A.pages[g==="GIRL"?"girl":"boy"]))||[];
    for(const meta of storyText.spreads){
      const pg=pages[meta.n-1]||{};
      for(const side of ["L","R"]){
        const wrap=document.createElement("div");
        wrap.className="story-page "+(side==="L"?"story-page-left":"story-page-right");
        const isText=(meta.text_side==="left"&&side==="L")||(meta.text_side==="right"&&side==="R");
        wrap.appendChild(isText ? await makeTextPage(meta,pg[side],name,g) : makeImgPage(pg[side]));
        grid.appendChild(wrap);
      }
    }
  }

  async function renderAll(){
    const profile=await loadProfile(); const name=profile&&profile.name, g=profile&&profile.gender;
    const tone=(profile&&profile.skinTone)||"light";
    if(!name||!g){ window.location.replace("/pages/personalise-book-bedtime"); return; }
    const cn=document.getElementById("child-name"); if(cn) cn.innerText=`For: ${name}`;
    const rn=document.getElementById("recipient-name"); if(rn) rn.innerText=name;
    await renderCover("coverCanvas","soft",name,g,tone);
    await renderCover("hardCoverCanvas","hard",name,g,tone);
    await renderBack("backCanvas","soft",name,g);
    await renderBack("hardBackCanvas","hard",name,g);
    await renderPhoto(profile); await renderDed(profile);
    await renderStory(name,g,tone);
  }

  function wireModals(){
    const openPhoto=document.getElementById("personalize-photo-btn"), photoModal=document.getElementById("photo-modal");
    const openMsg=document.getElementById("write-dedication-btn"), msgModal=document.getElementById("message-modal");
    // photo modal elements + preview UI helpers (mirror Blessed image-upload-preview UX)
    const fileIn=document.getElementById("customImage"), prev=document.getElementById("photo-preview");
    const pc=document.getElementById("photo-preview-container"), ua=document.getElementById("upload-area"), rm=document.getElementById("remove-photo");
    function showPhotoPreview(src){ if(prev){prev.src=src; prev.style.display="block";} if(pc)pc.style.display="flex"; if(rm)rm.style.display="block"; if(ua)ua.style.display="none"; }
    function resetPhotoUI(){ if(prev){prev.src=""; prev.style.display="none";} if(rm)rm.style.display="none"; if(ua)ua.style.display="block"; if(fileIn)fileIn.value=""; }
    // Downscale any photo to a print-sufficient size + re-encode as JPEG (small, fast upload;
    // accept any size, no reject). Backend now accepts JPEG (validPNGFileUploaded allows jpeg).
    function resizeImageFile(file, maxDim){
      return new Promise((resolve,reject)=>{
        const url=URL.createObjectURL(file); const img=new Image();
        img.onload=()=>{ URL.revokeObjectURL(url);
          const scale=Math.min(1, maxDim/Math.max(img.width,img.height));
          const w=Math.max(1,Math.round(img.width*scale)), h=Math.max(1,Math.round(img.height*scale));
          const cv=document.createElement("canvas"); cv.width=w; cv.height=h;
          cv.getContext("2d").drawImage(img,0,0,w,h);
          resolve(cv.toDataURL("image/jpeg", 0.9)); };
        img.onerror=()=>{ URL.revokeObjectURL(url); reject(new Error("decode failed")); };
        img.src=url;
      });
    }
    if(openPhoto&&photoModal){ openPhoto.onclick=async()=>{ const p=await loadProfile(); if(p&&p.imageBase64){ showPhotoPreview(p.imageBase64); } else { resetPhotoUI(); } photoModal.style.display="flex"; }; }
    if(openMsg&&msgModal){ openMsg.onclick=async()=>{ const p=await loadProfile(); const ta=document.getElementById("customMessage"); if(ta) ta.value=(p&&p.dedicationText)||""; msgModal.style.display="flex"; }; }
    const cP=document.getElementById("close-photo-modal"); if(cP) cP.onclick=()=>photoModal.style.display="none";
    const cM=document.getElementById("close-message-modal"); if(cM) cM.onclick=()=>msgModal.style.display="none";
    // photo upload — resize client-side (accept any size), then show preview immediately
    if(fileIn){ fileIn.onchange=async()=>{ const f=fileIn.files[0]; if(!f) return;
      try{ showPhotoPreview(await resizeImageFile(f, 1600)); }
      catch(e){ /* undecodable (e.g. some HEIC) — fall back to the raw file */
        const r=new FileReader(); r.onload=(ev)=>showPhotoPreview(ev.target.result); r.readAsDataURL(f); }
    }; }
    const savePhoto=document.getElementById("save-photo"); if(savePhoto){ savePhoto.onclick=async()=>{ const p=await loadProfile(); const src=prev&&prev.src; if(src&&src.startsWith("data:")){ await saveProfile({...p,imageBase64:src}); } photoModal.style.display="none"; renderAll(); }; }
    if(rm){ rm.onclick=async()=>{ const p=await loadProfile(); await saveProfile({...p,imageBase64:""}); resetPhotoUI(); renderAll(); }; }
    // dedication save
    const saveMsg=document.getElementById("save-message"); if(saveMsg){ saveMsg.onclick=async()=>{ const p=await loadProfile(); const ta=document.getElementById("customMessage"); const txt=(ta&&ta.value)||"";
      if(txt.length>400){ const er=document.getElementById("message-error"); if(er){er.textContent="Please keep your message under 400 characters.";er.style.display="block";} return; }
      await saveProfile({...p,dedicationText:txt}); msgModal.style.display="none"; renderAll(); }; }
  }

  document.addEventListener("DOMContentLoaded", async function(){
    try{
      const [cc, ex, st, sp] = await Promise.all([
        fetch(A.coords_cover).then(r=>r.json()),
        fetch(A.coords_extras).then(r=>r.json()),
        fetch(A.coords_story).then(r=>r.json()),
        fetch(A.coords_story_pos).then(r=>r.json()),
      ]);
      coverCoords = cc.covers; extras = ex; storyText = st; storyCoords = sp.items;
      try{ await document.fonts.load("300px Chewy"); await document.fonts.load("60px Newsreader"); }catch(e){}
      wireModals();
      const cont=document.getElementById("continue-to-format-btn"); if(cont) cont.onclick=()=>window.location.href="/pages/format-bedtime";
      await renderAll();
    }catch(e){ console.error("Bedtime preview error", e); }
  });
})();
